import { type VideoType, type VideoVariations } from '@Types/Blocks/Video';
import { type ContainerTypeEnums, type PositionsAlignement } from '@Types/Shared/Common';
import type { ContextKey, Options } from '@Types/Shared/Options';

import { useContext, type ComponentProps } from 'react';

import defu from 'defu';
import _ from 'lodash';

import { MinosContext } from '@Shared/Context';

import { VideoStyle } from '@/views/Shared/GlobalStyles/GlobalStyles';

import Video from './Block';

declare const minosOptions: string;

type VideoRegister = {
	block: VideoType;
	variant: VideoVariations;
	containerType: ContainerTypeEnums;
	headingAlign?: PositionsAlignement;
	context?: ContextKey;
};

export default function Register(props: VideoRegister) {
	const {
		block,
		variant = 'small',
		containerType = 'wide',
		headingAlign = 'center',
		context = 'front',
	} = props;

	const MinosOptions: Options =
		context === 'front' ? useContext(MinosContext) : JSON.parse(minosOptions);

	const { id, titleFormat, title, url, description, composition } = block;

	let propsVideo: ComponentProps<typeof Video> = {
		id: id ? id : '',
		title: title,
		description: description,
		titleFormat: titleFormat || 'h2',
		url: url,
		containerType: containerType,
		variant: variant,
		headingAlign: headingAlign,
		style: {},
		ctasStyle: MinosOptions.blocks.video.default.ctasStyle,
		placement: block.placement,
		sectionDecoration: MinosOptions.layout.sectionDecoration,
	};

	if (composition && composition != 'none') {
		const compoOptions = _.find(MinosOptions.blocks.video.compositions, { id: composition });
		if (compoOptions) {
			propsVideo = defu(compoOptions as ComponentProps<typeof Video>, propsVideo);
			propsVideo.style = VideoStyle(compoOptions);
		}
	}
	return (
		<>
			<Video {...propsVideo} />
		</>
	);
}
